import React, { useMemo } from "react";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
import { useTheme } from "../hooks/useTheme";
import { createMuiThemeFromMode } from "./theme";

const baseOptions = {
  palette: {
    secondary: { main: "#f5365c" },
    success: { main: "#2dce89" },
    warning: { main: "#fb6340" },
    info: { main: "#11cdef" },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    button: { textTransform: "none", fontWeight: 500 },
  },
  shape: { borderRadius: 8 },
};

/**
 * Wraps the app with MUI ThemeProvider using the global theme mode (default/dark/light).
 * Primary color = accent from src/theme/theme.js (AllEnquiries color in default/light, neon green in dark).
 */
export default function MuiThemeWrapper({ children }) {
  const { themeMode } = useTheme();
  const theme = useMemo(
    () => createTheme(createMuiThemeFromMode(themeMode, baseOptions)),
    [themeMode]
  );
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
